var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { UserMessageEnum } from '../auth/models/user-message-model';
import { of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { plainToClass } from 'class-transformer';
import { OrganizationModel } from '../organizations/models/organization.model';
import { HttpClient } from '@angular/common/http';
import { StorageService, SessionStorageEnum } from './storage.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./storage.service";
var UserMessageService = /** @class */ (function () {
    function UserMessageService(http, storageService) {
        this.http = http;
        this.storageService = storageService;
    }
    UserMessageService.prototype.getUserMessage = function (type, mode, checkCache) {
        var _this = this;
        if (mode === void 0) { mode = ''; }
        if (checkCache === void 0) { checkCache = true; }
        var cachedMessage = this.getCachedMessage(type);
        if (checkCache && cachedMessage) {
            return of(cachedMessage);
        }
        else {
            return this.http.get("/ws/user/message?version=2&type=" + type + "&mode=" + mode)
                .pipe(map(function (response) {
                var message_seen_id = response.message_seen_id, show_alert = response.show_alert;
                var responseValue;
                switch (type) {
                    // join organization
                    case UserMessageEnum.DomainAlert:
                        responseValue = plainToClass(OrganizationModel, response.join_organization);
                        break;
                    case UserMessageEnum.WelcomeTour:
                        responseValue = "" + response.tour_version;
                        break;
                    case UserMessageEnum.SurveyMonkey:
                        responseValue = "" + response.survey_group_name;
                        break;
                    default:
                        break;
                }
                return {
                    messageSeenId: message_seen_id,
                    messageType: type,
                    showUserAlert: show_alert,
                    messageData: responseValue
                };
            }), tap(function (response) {
                // cache when no user alert needed
                if (!response.showUserAlert) {
                    _this.addCachedMessage(response);
                }
            }));
        }
    };
    UserMessageService.prototype.setUserMessageViewed = function (messageSeenId) {
        return this.http.post("/ws/user/message", {
            version: 2,
            message_seen_id: messageSeenId
        });
    };
    UserMessageService.prototype.getCachedMessage = function (type) {
        var seenMessageCache = this.getCachedMessages();
        return seenMessageCache.find(function (message) { return message.messageType === type; });
    };
    UserMessageService.prototype.getCachedMessages = function () {
        var seenMessages = this.storageService.getSessionItem(SessionStorageEnum.UserMessagesSeen);
        return seenMessages || [];
    };
    UserMessageService.prototype.addCachedMessage = function (type) {
        if (!this.getCachedMessage(type.messageType)) {
            var seenMessages = this.getCachedMessages();
            this.storageService.setSessionItem(SessionStorageEnum.UserMessagesSeen, __spread(seenMessages, [type]));
        }
    };
    UserMessageService.ngInjectableDef = i0.defineInjectable({ factory: function UserMessageService_Factory() { return new UserMessageService(i0.inject(i1.HttpClient), i0.inject(i2.StorageService)); }, token: UserMessageService, providedIn: "root" });
    return UserMessageService;
}());
export { UserMessageService };
